<!--
  功能：功能描述
  作者：missfox
  邮箱：missfoxw@163.com
  时间：2021年09月24日 11:04:22
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
    <div class="history">
        <div class="history-top">
            <div class="task-name">
                <div class="task-container">
                    <el-image
                    class="task-image"
                    :src="time"></el-image>
                    <div class="task">{{message}}</div>
                </div>
                <div class="avatar-container">
                    <el-image
                    class="avatar-image"
                    fit="cover"
                    :src="elder.ImgUrl||avatar"></el-image>
                    <div class="name">{{elder.Name}}</div>
                </div>
            </div>
            <div class="icon-list">
                <div v-for="item in iconList" :key="item.text">
                    <div class="icon-container">
                        <el-image
                        class="icon-image"
                        :src="item.icon"></el-image>
                        <div class="icon-text">{{item.text}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="enter-list">
            <template v-if="implementHistory&&implementHistory.length">
                <div class="enter" v-for="item in implementHistory" :key="item.Id">
                    <div class="enter-top">
                        <div>
                            <span class="weight">时间：</span>
                            <span class="title-text">{{item.InputDate?item.InputDate.substr(0,item.InputDate.length-3).replace('T',' '):item.InputDate}}</span>
                        </div>
                        <div>
                            <span class="weight">护理员：</span>
                            <span class="title-text"> {{item.CUser}}</span>
                        </div>
                    </div>
                    <div class="line"></div>
                    <div class="enter-botoom">
                        <div>内容：</div>
                        <div class="icon-container">
                            <el-image
                            class="icon-image"
                            :src="iconList[item.Status].icon"></el-image>
                            <div class="icon-text">{{item.Value}}</div>
                            <div v-if="item.Remark" class="icon-text">{{item.Remark}}</div>
                        </div>
                    </div>
                </div>
            </template>
            <tips v-else></tips>
        </div>
    </div>
</template>

<script>
import { mapState ,mapActions } from 'vuex'
import tips from '@/common/tips.vue'

import time from '@/assets/imgs/time.png'
import avatar from '@/assets/imgs/avatar.png'
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {
      tips
  },
  // 组件状态值
  data () {
    return {
        time,
        avatar,
        message:'',
        iconList:[
            {
                icon:require('@/assets/imgs/wancheng.png'),
                text:"完成"
            },
            {
                icon:require('@/assets/imgs/jujue.png'),
                text:"拒绝"
            },
            {
                icon:require('@/assets/imgs/quexi.png'),
                text:"缺席"
            },
            {
                icon:require('@/assets/imgs/meibiyao.png'),
                text:"没有必要"
            },
            {
                icon:require('@/assets/imgs/weiwancheng.png'),
                text:"未完成"
            },
            {
                icon:require('@/assets/imgs/yanqi.png'),
                text:"延期"
            },
        ]
    }
  },
  // 计算属性
  computed: {
      ...mapState(['ElderlyCares','Items','NurseSignatureViews','saveVal']),
      ...mapState('filter',['selectDetails','selectRooms','activeShifts']),
        elder(){
            return this.ElderlyCares.filter(item=>item.Id==this.$route.query.Id)[0]
        },
      implementHistory(){
        // let ItemsArr=this.Items.filter(item=>{
        //     return item.ProfileName==this.elder.Name&&item.Status!=null
        // })
        let ItemsArr=this.Items.filter(item=>{
            return item.Id==this.$route.query.itemId
        })[0].HistoryRecords

        return ItemsArr||[]
    },
  },
  // 侦听器
  watch: {},
  // 组件方法
  methods: {},
  // 以下是生命周期钩子   注：没用到的钩子请自行删除
  /**
  * 在实例初始化之后，组件属性计算之前，如data属性等
  */
  beforeCreate () {
  },
  /**
  * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
  */
  created () {
  },
  /**
  * 在挂载开始之前被调用：相关的 render 函数首次被调用。
  */
  beforeMount () {
  },
  /**
  * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
  * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
  */
  mounted () {
      this.message=this.$route.query.message
  },
  /**
  * 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
  * 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
  */
  beforeUpdate () {
  },
  /**
  * 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
  * 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
  */
  updated () {
  },
  /**
  * keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
  */
  activated () {
  },
  /**
  * keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
  */
  deactivated () {
  },
  /**
  * 实例销毁之前调用。在这一步，实例仍然完全可用。
  */
  beforeDestroy () {
  },
  /**
  * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
  * 所有的事件监听器会被移除，所有的子实例也会被销毁。
  */
  destroyed () {
  }
}
</script> 

<style scoped>
.icon-text{
    margin-left: 3px;
}
.name,.task,.icon-text,.enter-botoom,.weight{
    font-weight: 500;
    font-family: 'PingFang SC Medium';
}
.history-top{
    background-color: #fff;
    padding: 15px;
}
.enter-list{
    margin: 0px 12px 12px 12px;
}
.task-name{
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
}
.task-container,.avatar-container{
    display: flex;
    align-items: center;
}

.task-container{
    font-size: 16px;
    color: #029FD1;
}
.task-image{
    margin-right: 3px;
    width: 24px;
    height: 24px;
}
.avatar-container{
    font-size: 14px;
    color: #0A0E10;
}
.avatar-image{
    margin-right: 7px;
    width: 34px;
    height: 34px;
    border-radius: 17px;
    border: 1px solid #029FD1;
    box-sizing: border-box;
}
.icon-list{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: 12px;
    color: #0A0E10;
}
.icon-container{
    display: flex;
    align-items: center;
}
.icon-image{
    width: 12px;
    height: 12px;
    margin-right: 3px;
}
.enter{
    font-size: 14px;
    color: #0A0E10;
    margin: 10px 0px;
    padding: 15px;
    border-radius: 8px;
    background: #fff;
}
.title-text{
    font-size: 12px;
    color: #7C7E80;
    margin-left: 3px;
}
.enter-top,.enter-botoom{
    display: flex;
}
.line{
    width: 100%;
    height: 1px;
    background: #EBEBEB;
}
.enter-top{
    justify-content: space-between;
    margin-bottom: 15px;
}
.enter-botoom{
    align-items: center;
    margin-top: 15px;
    padding-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/implement-history.vue